export default function Footer() {
  return (
    <footer className="bg-[#022C22] pb-10" data-testid="site-footer">
      <div className="mx-auto max-w-7xl border-t border-[#F5F5F4]/10 px-6 pt-14 md:px-12">
        <div className="flex flex-col justify-between gap-10 md:flex-row md:items-end">
          <div>
            <span className="block text-[11px] font-semibold tracking-[0.42em] text-[#F5F5F4]/60">EMBASSY</span>
            <span className="font-display block text-3xl tracking-[0.14em] text-[#FAF9F6]">SOUTH RESERVE</span>
            <p className="mt-4 max-w-sm text-xs leading-relaxed text-[#F5F5F4]/45">
              At Embassy Origins, near Tarahunise Lake, North Bengaluru.
            </p>
          </div>
          <div className="text-xs leading-relaxed text-[#F5F5F4]/45 md:text-right">
            <p data-testid="footer-rera">
              RERA: PRM/KA/RERA/1251/310/PR/180217/002476
            </p>
            <p className="mt-1">rera.karnataka.gov.in</p>
          </div>
        </div>
        <p className="mt-14 border-t border-[#F5F5F4]/10 pt-8 text-[11px] leading-relaxed text-[#F5F5F4]/35">
          All text and images are for advertising purposes only. The company reserves the right to
          amend the details specified herein without prior notice. The furniture shown in visuals
          and floor plans is illustrative and does not form part of the offering or specification.
        </p>
      </div>
    </footer>
  );
}
